export default {
  'button.back': 'Quay lại',
  'button.back.home': 'Trở về',
  'button.search': 'Tìm kiếm',
  'button.reset': 'Làm lại',
  'button.edit': 'Chỉnh sửa',
  'button.delete': 'Xoá',
  'button.submit': 'Xác nhận',
  'button.close': 'Đóng',
  'button.view': 'Chi tiết',
  'button.yes': 'Có',
  'button.no': 'Không',
  'button.update': 'Cập nhật',
  'button.add': 'Thêm',
  'button.cancel': 'Hủy',
  'button.lock': 'Khóa',
  'button.unlock': 'Mở khóa',
  'button.import': 'Nhập',
  'button.export': 'Xuất',
  'button.save': 'Lưu',
  'button.register': 'Đăng ký',
  'button.loginWithAccessToken': 'Đăng nhập bằng access token',
  'button.loginWithToken': 'Đăng nhập bằng token',
  'button.login': 'Đăng nhập',
  'button.info': 'Chi tiết',
  'user.button.viewProfile': 'Thông tin cá nhân',
  'user.button.logout': 'Đăng xuất',
  'user.button.changePassword': 'Đổi mật khẩu',
};
